import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getBuildHash } from 'app/shared/functions/get-build-hash';
import { Observable } from 'rxjs';

const JSON_ASSET_PREFIXES = [
    /^\.?\/assets\//i,   // './assets/...'
    /^\/assets\//i,      // '/assets/...'
    /^\/static\//i,       // add more if needed
];

const JSON_API_EXCLUDES = [
    /^\/api\//i,                         // your backend
    /\/graphql($|[/?#])/i,               // if applicable
    /^https?:\/\/[^/]+\/api\//i,          // absolute API URLs
];

function isSameOriginAbsolute(url: string): boolean {
    try {
        const u = new URL(url);

        return u.origin === window.location.origin;
    } catch {
        // relative URL → treat as same origin
        return true;
    }
}

function isJsonAsset(url: string): boolean {
    // Ends with .json (ignore existing query/hash)
    const clean = url.split(/[?#]/)[0];
    if (!/\.json$/i.test(clean)) {
        return false;
    }

    // Must be under allowed prefixes
    const path = ((): string => {
        try {
            return new URL(url, window.location.origin).pathname;
        } catch {
            return url;
        }
    })();

    if (!JSON_ASSET_PREFIXES.some(rx => rx.test(path))) {
        return false;
    }

    if (JSON_API_EXCLUDES.some(rx => rx.test(path))) {
        return false;
    }

    return true;
}

@Injectable()
export class JsonCacheBustInterceptor implements HttpInterceptor {
    public intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        if (req.method !== 'GET') {
            return next.handle(req);
        }

        if (!isSameOriginAbsolute(req.url)) {
            return next.handle(req);
        } // avoid 3rd-party

        if (!isJsonAsset(req.url)) {
            return next.handle(req);
        }

        const v = getBuildHash();
        const params = (req.params || new HttpParams()).set('v', v);

        return next.handle(req.clone({ params }));
    }
}
